<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item label="支付名称" prop="showName">
        <el-input v-model="dataForm.showName" placeholder="支付名称"></el-input>
      </el-form-item>
      <el-form-item label="显示名称" prop="payName">
        <el-input v-model="dataForm.payName" placeholder="显示名称"></el-input>
      </el-form-item>
      <el-form-item label="启用状态" prop="status">
        <el-switch v-model="dataForm.status" :active-value="1" :inactive-value="2"></el-switch>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" type="textarea" placeholder="数字货币支付"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        showName: '',
        payName: '',
        status: 1,
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        showName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { min: 1, max: 100, message: '支付名称长度在1-100字符之间', trigger: 'blur' }
        ],
        payName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { min: 1, max: 100, message: '显示名称长度在1-100字符之间', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/crypto/payconfig/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/crypto/payconfig', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
